/**
 * Genera un event_id hexadecimal para Meta Pixel / CAPI (deduplicación).
 * Basado en timestamp en ms (hex) + entropía corta para evitar colisiones en el mismo ms.
 */
export function generateMetaPurchaseEventId() {
  const tsHex = Date.now().toString(16);
  const rand = Math.floor(Math.random() * 0x100000000).toString(16).padStart(8, '0');
  return `${tsHex}${rand}`;
}
